module.exports = __webpack_public_path__ + "static/media/outland-denim-pants.84867ed5.png";